import Borghi from './borghi'
import { useState, useRef } from 'react'

const weekday = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"]

function Ticket({ prezzo, opzioniBiglietto, url, oraInizio, dataInizio, oraFine, dataFine, indirizzo, comune, provincia, città, img }) {
    const [borghi, setBorghi] = useState([])

    const weekDayStart = useRef()
    const weekDayEnd = useRef()

    weekDayStart.current = weekday[new Date(dataInizio).getDay()]
    weekDayEnd.current = weekday[new Date(dataFine).getDay()]

    const dataFromBorghi = (dataFromBorghi) => { setBorghi(dataFromBorghi) }

    return (<>
        <div id='ticket' className='eventiDetailsDate mt-5 pt-1'>
            {/* ------------------ PREZZO BIGLIETTO ----------------- */}
            {prezzo !== '0' && prezzo !== 'vai al sito web' ?
                <div style={{ display: 'inline-block' }}>
                    <p className='btn btn-primary text-light ms-1'>Ingresso: € {prezzo}</p>
                    <p style={{ margin: '0 0 10px 0', fontSize: '15px' }}>
                        <i>{opzioniBiglietto}</i>
                    </p>
                </div>
                : prezzo === '0' ?
                    <div style={{ marginLeft: '5px', display: 'inline-block' }}>
                        <div className='btn btn-primary text-light border-dark ms-1' style={{ padding: '3% 3%' }}>
                            <p style={{ fontWeight: '600' }}>INGRESSO GRATUITO</p>
                        </div>
                    </div>
                    : prezzo === 'vai al sito web' ?
                        <div style={{ display: 'inline-block' }}>
                            <a className='btn btn-primary text-light ms-1' style={{ color: 'white', textDecoration: 'none' }} href={url} target="_blank" rel="noopener noreferrer">
                                Biglietto ⇉ vai al sito web</a>
                        </div>
                        : null
            }
            {/* --------------- DATE ------------------ */}
            <div className='border-top border-bottom border-start ps-1'>
                <p style={{ fontSize: 'medium', marginBottom: '1rem', fontWeight: '600', color: 'navy' }}>📅 SALVA LA DATA</p>
                <div className='ms-3'>da {weekDayStart.current.substring(0, 3)} {dataInizio.split("-").reverse().join("-")}
                    {oraInizio && <span> ore {oraInizio}</span>}
                </div>
                <p className='ms-3'>a {weekDayEnd.current.substring(0, 3)} {dataFine.split("-").reverse().join("-")}
                    {oraFine && <span> ore {oraFine}</span>}
                </p>
                <p className='addImg'><i>{indirizzo}</i>, {comune} ({provincia})</p>
            </div>

            {/* -------------------- IMMAGINE N.3 oppure IMMAGINE CITTA' ------------------------ */}
            {img.length === 3 ?
                <img src={`https://leuro-bucket.s3.amazonaws.com/${img[2]}`} className="card-img-top addImg" style={{ borderRadius: "15px" }} alt='' />
                :
                <div className='addImg'>
                    <h5 style={{ padding: '1px 5px' }}>
                        {città === comune ? <span>Evento a </span> : <span>Evento in provincia di </span>}
                        {città} 🏰
                    </h5>
                    <Borghi onDataSubmit={dataFromBorghi} />
                    {borghi.filter(item => item.città === città).length !== 0 &&
                        borghi
                            .filter(item => item.città === città)
                            .map((borgo, index) => (
                                <div key={index}>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/città/${borgo.imgCittà}`} className="card-img-top"
                                        style={{ paddingRight: '1em' }} alt='' />
                                </div>
                            ))
                    }
                </div>
            }
        </div>
    </>)
}
export default Ticket